import { __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { apiHolder, apis, locationHelper } from 'api';
import { MailActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { getFileIcon } from '@web-disk/utils';
import { config } from 'env_def';
import IconCard from '@web-mail/components/Icon';
import { getIn18Text } from 'api';
import { getvarList } from '@web-mail-write/components/SendMail/utils';
const diskApi = apiHolder.api.requireLogicalApi(apis.netStorageImpl);
export default (Component) => {
    const PastePre = (props) => {
        const dispatch = useAppDispatch();
        const { systemVariableList, customVariableList } = useAppSelector(state => state.configReducer);
        const [variableList, setVariableList] = useState();
        useEffect(() => {
            const data = getvarList(systemVariableList, customVariableList);
            data && setVariableList(data);
        }, [systemVariableList, customVariableList]);
        const host = locationHelper.getHost();
        const contextPath = config('contextPath');
        const { forwardedRef } = props, rest = __rest(props, ["forwardedRef"]);
        const diskUrlRegExp = new RegExp(`(href=["'])?((https:\/\/sirius-desktop-web\\d?.cowork.netease.com)|(https://${host}${contextPath})|(https:\/\/lingxi.office.163.com))\/((doc)|(sheet)|(share))\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]`, 'g');
        const replaceUrlAction = async (editor, urls, urlIdMap) => {
            const res = await diskApi.getLinkInfoBatch({
                linkUrls: urls,
            });
            urls.forEach(url => {
                const content = res[url];
                if (content && content.content) {
                    const { name } = content.content;
                    let fileType = getFileIcon(content.content);
                    if (content.result.resourceType === 'DIRECTORY')
                        fileType = 'folder';
                    if (fileType === getIn18Text('WEIZHI'))
                        fileType = 'other';
                    const iconHTML = ReactDOMServer.renderToString(React.createElement(IconCard, { type: fileType, width: "16px", height: "16px" }));
                    const iconBase64 = `data:image/svg+xml;base64,${window.btoa(iconHTML)}`;
                    const iconImg = editor.dom.createHTML('img', {
                        src: iconBase64,
                        style: 'margin-right: 3px; top: 2px; position: relative; display: inline-block',
                    });
                    const nameHTML = editor.dom.createHTML('span', {}, name);
                    const aHTML = editor.dom.createHTML('a', { href: url, contenteditable: false, style: 'cursor: pointer; text-decoration: none' }, iconImg + nameHTML);
                    const divHTML = editor.dom.createHTML('div', {}, aHTML);
                    const el = editor.getDoc().querySelector('#' + urlIdMap[url]);
                    if (el) {
                        editor.undoManager.transact(function () {
                            el.innerHTML = divHTML;
                        });
                    }
                }
            });
        };
        const replaceUrl = (editor, text, urls) => {
            console.log('replaceUrlreplaceUrl');
            if (!urls || !urls.length)
                return;
            const urlIdMap = {};
            const urlContents = {};
            urls.forEach(url => {
                const id = `url${Math.random().toString(36).substr(2, 10)}`;
                urlIdMap[url] = id;
                urlContents[url] = editor.dom.createHTML('div', { id }, url);
            });
            const resText = text.replace(diskUrlRegExp, match => {
                if (match.startsWith('href=')) {
                    return match;
                }
                return urlContents[match];
            });
            replaceUrlAction(editor, urls, urlIdMap);
            return resText;
        };
        const recognizeDiskUrl = (editor, clipboardContent) => {
            var _a;
            const html = (_a = clipboardContent['text/html']) === null || _a === void 0 ? void 0 : _a.replace(/amp;/g, '');
            const plain = clipboardContent['text/plain'];
            let text = html || plain;
            if (text && text.length > 1000) {
                dispatch(MailActions.doSetWirteMailSpin(true));
            }
            if (text) {
                const diskUrls = text.match(diskUrlRegExp);
                const urls = diskUrls === null || diskUrls === void 0 ? void 0 : diskUrls.filter(url => !url.startsWith('href='));
                const oldUrls = diskUrls === null || diskUrls === void 0 ? void 0 : diskUrls.filter(url => url.startsWith('href='));
                if (urls && urls.length) {
                    text = replaceUrl(editor, text, urls);
                }
                if (oldUrls) {
                }
                if (process.env.BUILD_ISEDM) {
                    text = text.replace(/\#\{([^}]+)\}/g, (match, p1) => {
                        const varShow = variableList === null || variableList === void 0 ? void 0 : variableList.codeToShow[p1];
                        if (varShow) {
                            return `<span class="mce-lx-var mceNonEditable" contenteditable="false" data-var="#{${p1}}" data-var-show="[${varShow}]" >[${varShow}]</span>`;
                        }
                        return match;
                    });
                }
            }
            clipboardContent['text/html'] = text;
            return false;
        };
        return React.createElement(Component, Object.assign({ recognizeDiskUrl: recognizeDiskUrl, ref: forwardedRef }, rest));
    };
    return React.forwardRef((props, ref) => React.createElement(PastePre, Object.assign({}, props, { forwardedRef: ref })));
};
